export function toImportableDate(date) {
  //desired date format in locatime yyyy-MM-dd HH:mm:ss
  return `${date.getFullYear()}-${twoDidgit(date.getMonth()+1)}-${twoDidgit(date.getDate())} ${twoDidgit(date.getHours())}:${twoDidgit(date.getMinutes())}:${twoDidgit(date.getSeconds())}`;
}

function twoDidgit(num) {
  return ("0" + num).slice(-2);
}